import type { SxProps } from "@mui/material";

export const useGetTagSX = (clickable?: boolean): SxProps => ({
  borderRadius: 1,
  ...(clickable && {
    "&:hover": {
      borderColor: "grey.700",
    },
  }),
});
